export default __webpack_public_path__ + "static/media/32_Bazant_obecny_www.mezistromy.cz_thumb-min.45cd92f5.jpg";